import axios from 'axios'
import { message } from 'ant-design-vue'
import { getToken, removeToken } from './auth'
import router from '@/router'

const service = axios.create({
  // 相对路径：开发态经 vue.devServer.proxy → 网关 8087；生产态同域反代到网关
  // 所有 /admin /api /file 禁止直连业务服务端口
  baseURL: process.env.VUE_APP_BASE_API || '',
  timeout: 30000
})

service.interceptors.request.use(config => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = token
  }
  // 有 JSON body 时显式声明，避免 axios 默认 form-urlencoded 撞上 @RequestBody
  if (config.data != null && typeof config.data === 'object' && !(config.data instanceof FormData)) {
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
  }
  return config
}, error => Promise.reject(error))

service.interceptors.response.use(response => {
  const res = response.data
  if (res && res.status === true) {
    return res
  }
  const msg = (res && res.message) || '请求失败'
  message.error(msg)
  // 未登录 / 无权限
  if (res && (res.code === '401' || res.code === '403')) {
    removeToken()
    router.replace({ path: '/login' })
  }
  return Promise.reject(new Error(msg))
}, error => {
  message.error(error.message || '网络异常')
  return Promise.reject(error)
})

export default service
